import SelectItem from '@/common/interfaces/SelectItem';

export enum ChoiseType {
  FriendsAndFamily = '1',
  Me = '3',
  Both = '2',
}

export interface DerSubscribeBlockViewModel {
  Destinations: SelectItem[];
  Choises: SelectItem[];
  PrivacyPolicyLink: string;
  BottomText?: string;
  IsNotShowSecondFormPart?: boolean;
  PrePopulateDestinationId?: number;
  PrePopulateItineraryId?: number;
  PrePopulateDepartureNumber?: number;
}
